/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Link, Redirect, withRouter } from "react-router-dom";
import { Statistic, Row, Col, Result, Button, Alert, Modal } from "antd";
import { chain } from "lodash";
/* import QRCode from 'qrcode.react'; */
import { request } from "axios/request";
import Clear from "../Clear";
import InstallmentSelection from "./InstallmentSelection";
import {
  CASH_PAYMENT_TYPE,
  INSTALLMENT_PAYMENT_TYPE,
} from "constants/checkout";
import {
  askToCash,
  sendSmsToCustomerPhone,
  sendQrCodeWithEmail,
  clearRedirect,
} from "actions/checkout";
import { fetchBasket } from "actions/basket";
import $S from "theme/settings";
import TPP from "hooks/TPP";
import { customerLogout } from "actions/customerList";
import { copyClipboard, isDefined } from "utils";
import { objectSelector } from "theme/utils";
import FundTransferTFS from "./tfs/FundTransferTFS";
import giftIcon from "theme/svg/gift-logo.svg";

import $T from "plugins/tfs/platformConfigs/theme/checkout.json";
const $A = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/app`);

const {
  DIRECTORY_THEME,
} = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/staticTextMaps/checkout`);

const $R = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/routes`);
const $STM = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/staticTextMaps/checkout`);
const $STA = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/staticTextMaps/app`);
const $BRAND_CONFIG = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/app.json`);
const $ST = DIRECTORY_THEME.PAYMENT_SELECTION;

const BANCONTACT_SLUGS = ["msext_bancontact", "multisafepay_bancontact"];
const FUNDS_TRANSFER_PAYMENT_TYPE = "funds_transfer";

const { Countdown } = Statistic;
class PaymentOptions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bankId: undefined,
      cardId: undefined,
      paymentType: undefined,
      installmentId: undefined,
      hasBarcodeRequest: false,
      qrCodeShow: false,
      orderCreated: false,
      counter: 0,
      showResultText: false,
      paymentOptionsScreen: true,
      deadline: Date.now() + 1000 * 60 * 30 + 1000,
      barcodeTimeCounter: 0,
      isClickBarcodeButton: false,
      barcodeTimeIsUp: false,
      customerPhoneNumber: "",
      isAlert: false,
      isQrCodeToEmailAlert: false,
      goToBasket: false,
      ivrTimeCounter: 0,
      ivrTimeIsUp: false,
      ivrIsActive: false,
      isClickIvrButton: false,
      paymentTypeIVR: false,
      copyQr: {
        text: "Kopyala",
        isCoppied: false,
      },
      redirectionComplete: false,
      isClickFundTransfer: false,
    };

    this.payWithCashButtonClickDate = React.createRef();
  }

  get hasInstallment() {
    const { context } = this.props;
    const { installment_options, barcode } = context;
    const { paymentType } = this.state;
    return (
      !barcode &&
      paymentType === INSTALLMENT_PAYMENT_TYPE &&
      installment_options.length > 0 &&
      true
    );
  }

  checkOrderStatus = () => {
    const orderStatusUrl =
      "orders" + this.props.orderStatusUrl.split("/orders")[1];
    setTimeout(() => {
      if (this.state.orderCreated === true || this.state.counter === 1800) {
        if (this.state.orderCreated) {
          this.props.dispatch(customerLogout());
        }
        this.setState({ showResultText: true });
      } else {
        request({
          url: orderStatusUrl,
          method: "GET",
        }).then((response) => {
          this.setState({
            orderCreated: response.data.order_created,
          });
        });
        this.setState((prevState) => {
          return {
            counter: prevState.counter + 1,
          };
        });
      }
    }, 1000);
  };

  // IVR için ÖDEME
  checkOrderStatusIVR = () => {
    const { dispatch, context } = this.props;
    const { number } = context;
    const { ivrTimeCounter, ivrTimeIsUp } = this.state;
    if (!ivrTimeIsUp) {
      this.intervalIvr = setTimeout(() => {
        if (ivrTimeCounter >= 360) {
          this.setState({
            ivrTimeIsUp: true,
            ivrTimeCounter: 0,
          });
        } else {
          dispatch(askToCash(number));
          this.setState({
            // eslint-disable-next-line react/no-direct-mutation-state
            ivrTimeCounter: ++this.state.ivrTimeCounter,
          });
        }
      }, 5000);
    }
  };

  checkBarcodePaymentStatus = () => {
    const { barcodeTimeIsUp } = this.state;

    if (isDefined(this.payWithCashButtonClickDate.current)) {
      const diffInMillis = Math.abs(
        new Date() - this.payWithCashButtonClickDate.current
      );
      const diffInMinutes = Math.floor(diffInMillis / 60000);

      if (
        !barcodeTimeIsUp &&
        diffInMinutes >= $T.BARCODE_TIME_LIMIT_IN_MINUTES
      ) {
        this.setState({
          barcodeTimeIsUp: true,
        });
      }
    }
  };

  againStartBarcodeGet = () => {
    const { dispatch } = this.props;

    this.payWithCashButtonClickDate.current = new Date();
    this.setState({
      barcodeTimeIsUp: false,
    });

    dispatch(askToCash());
  };

  againStartIvrGet = () => {
    this.setState({
      ivrTimeIsUp: false,
    });
    this.checkOrderStatusIVR();
  };

  componentDidMount() {
    const {
      dispatch,
      paymentOptions,
      currentPaymentOption,
      onSetPaymentOption,
      customer,
    } = this.props;

    const cashRegister = paymentOptions.filter((el) => {
      return el.payment_type === "cash_register";
    });

    if ($STA.BRAND === "Samsung") {
      const localCurrentStaff =
        (localStorage.getItem("usedStorage") !== undefined &&
          localStorage.getItem("usedStorage") !== "undefined" &&
          JSON.parse(localStorage.getItem("usedStorage"))) ||
        {};

      const hasntIvrBtn = ["Teknisyen"];

      if (
        $STA.BRAND === "Samsung" &&
        !hasntIvrBtn.includes(localCurrentStaff.name)
      ) {
        this.setState({
          paymentTypeIVR: true,
        });
      }
      if (!currentPaymentOption) {
        if (cashRegister.length > 0) {
          onSetPaymentOption(cashRegister[0].pk);
        }
      }
      dispatch(fetchBasket());
      this.setState({
        customerPhoneNumber: customer.phone,
      });
    } else {
      const { dispatch } = this.props;
      dispatch(fetchBasket());
      if (!currentPaymentOption) {
        if (cashRegister.length > 0) {
          onSetPaymentOption(cashRegister[0].pk);
        }
      }
      this.setState({
        customerPhoneNumber: this.props.customer.phone,
      });
    }
  }

  componentDidUpdate(_, prevState) {
    const { context } = this.props;
    const {
      isAlert,
      counter,
      qrCodeShow,
      showResultText,
      paymentTypeIVR,
      isClickBarcodeButton,
      isClickIvrButton,
      isQrCodeToEmailAlert,
    } = this.state;

    if ($STA.BRAND === "Samsung") {
      if (paymentTypeIVR && isClickIvrButton) {
        this.checkOrderStatusIVR();
      } else {
        if (counter <= 1800 && !isQrCodeToEmailAlert) {
          let id = window.setTimeout(function () {}, 0);
          while (id--) {
            window.clearTimeout(id);
          }
          !paymentTypeIVR &&
            qrCodeShow &&
            !showResultText &&
            this.checkOrderStatus();
          isClickBarcodeButton && this.checkBarcodePaymentStatus();
        }
        if (isAlert) {
          setTimeout(() => this.setState({ isAlert: false }), 2000);
        }
        if (isQrCodeToEmailAlert) {
          setTimeout(() => {
            this.setState({ isQrCodeToEmailAlert: false });
          }, 2000);
        }
      }
    } else {
      if (this.state.counter <= 1800 && !isQrCodeToEmailAlert) {
        let id = window.setTimeout(function () {}, 0);
        while (id--) {
          window.clearTimeout(id);
        }

        this.state.qrCodeShow &&
          !this.state.showResultText &&
          this.checkOrderStatus();
        this.state.isClickBarcodeButton && this.checkBarcodePaymentStatus();
      }
      if (this.state.isAlert) {
        setTimeout(() => this.setState({ isAlert: false }), 2000);
      }
      if (isQrCodeToEmailAlert) {
        setTimeout(() => {
          this.setState({ isQrCodeToEmailAlert: false });
        }, 2000);
      }
    }
    // Bancontact redirect
    if (Boolean(context.redirect) && !this.state.redirectionComplete) {
      const { qrUrl } = this.props;
      window.open(qrUrl, "_blank");

      this.handleRedirectionComplete();
    }
  }

  handleRedirectionComplete = () => {
    const { dispatch } = this.props;
    this.setState({
      redirectionComplete: true,
      qrCodeShow: true,
      deadline: Date.now() + 1000 * 60 * 30 + 1000,
    });

    dispatch(clearRedirect());
  };

  componentWillUnmount() {
    clearTimeout(this.intervalIvr);
    const headerElement = document.getElementById("js-header");
    if (headerElement) {
      headerElement.style.display = "block";
    }
    localStorage.setItem("orderNumber", JSON.stringify(0));
  }

  resetCardSelection = () =>
    this.setState({ installmentId: null, cardId: null });

  handlePaymentTypeSelection = (paymentType) => {
    const { onSetPaymentType, context } = this.props;
    const { number } = context;
    localStorage.setItem("orderNumber", JSON.stringify(number));
    if (paymentType === CASH_PAYMENT_TYPE) {
      this.payWithCashButtonClickDate.current = new Date();
    }
    this.setState(
      {
        paymentType,
        paymentOptionsScreen: false,
        isClickBarcodeButton: $STA.BRAND === "Samsung" ? false : true,
        isClickIvrButton: $STA.BRAND === "Samsung" ? true : false,
      },
      () => onSetPaymentType && onSetPaymentType(paymentType)
    );
  };

  renderInstallment() {
    const handleInstallmentSelection = (installmentId) => {
      this.setState({ installmentId }, () => {
        this.props.onSelectInstallmentId(installmentId);
      });
    };
    const handleCardSelection = (cardId) => {
      this.setState({ cardId, installmentId: undefined }, () => {
        this.props.handleCardSelection(cardId);
      });
    };
    const handleBankSelection = (bankId) =>
      this.setState({ bankId, cardId: undefined, installmentId: undefined });
    const { context } = this.props;
    const { installment_options = [] } = context;
    const { bankId, cardId, installmentId } = this.state;
    const banks = chain(installment_options)
      .uniqBy((card) => card.bank.pk)
      .map(({ bank }) => bank)
      .sortBy("name")
      .value();

    return (
      <InstallmentSelection
        banks={banks}
        context={context}
        cards={installment_options}
        bankId={bankId}
        cardId={cardId}
        installmentId={installmentId}
        onSetBankOption={handleBankSelection}
        onSetCardOption={handleCardSelection}
        onSetInstallmentOption={handleInstallmentSelection}
      />
    );
  }

  payWithBancontact = () => {
    const { onSetPaymentOption, context } = this.props;

    const bancontactPaymentOption = BANCONTACT_SLUGS.map((slug) =>
      context.payment_options.find((option) => option.slug === slug)
    ).find((option) => option);

    const bancontactPaymentOptionPk = objectSelector(
      bancontactPaymentOption,
      "pk"
    );

    if (bancontactPaymentOptionPk) {
      onSetPaymentOption(bancontactPaymentOptionPk);
    }
  };

  payWithQR = () => {
    this.payWithBancontact();
  };

  handleCancel = () => {
    this.setState({
      showResultText: false,
      qrCodeShow: false,
      counter: 0,
      deadline: Date.now() + 1000 * 60 * 30 + 1000,
    });
  };

  backToPayWithQr = () => {
    this.setState({
      showResultText: false,
      counter: 0,
      deadline: Date.now() + 1000 * 60 * 30 + 1000,
    });
  };

  backToPaymentOptions = () => {
    this.setState({
      paymentOptionsScreen: true,
    });
    this.props.context.barcode = false;
  };

  setCustomerPhoneNumber = (e) => {
    this.setState({
      customerPhoneNumber: e.target.value,
    });
  };

  sendSmsToCustomer = () => {
    const { dispatch } = this.props;
    const { customerPhoneNumber } = this.state;
    dispatch(sendSmsToCustomerPhone(customerPhoneNumber));
    this.setState({
      isAlert: true,
    });
  };

  sendQrCodetoEmail = () => {
    const { dispatch } = this.props;
    dispatch(sendQrCodeWithEmail());
    this.setState({
      isQrCodeToEmailAlert: true,
    });
  };

  onSetPaymentWithFundTransfer = () => {
    const {
      context: { payment_options },
      onSetPaymentOption,
    } = this.props;

    if (payment_options) {
      const { pk } =
        payment_options.find(
          ({ payment_type }) =>
            Boolean(payment_type) &&
            payment_type === FUNDS_TRANSFER_PAYMENT_TYPE
        ) || {};
      if (pk) {
        onSetPaymentOption(pk);
        this.setState({ isClickFundTransfer: true });
      }
    }
  };

  onFundsTransferChoicePage = (bank_account) => {
    const { onSetFundsTransferChoicePage } = this.props;
    if (bank_account) {
      onSetFundsTransferChoicePage(bank_account);
    }
  };

  onPayWithFundTransfer = (agreement) => {
    const { onSetPaymentFundTransfer } = this.props;
    if (agreement) {
      onSetPaymentFundTransfer(agreement);
    }
  };

  closeModal = () => {
    Modal.confirm({
      title: <TPP path="PAYMENT_SELECTION.CLOSE_MODAL.TITLE" />,
      content: <TPP path="PAYMENT_SELECTION.CLOSE_MODAL.CONTENT" />,
      cancelText: <TPP path="PAYMENT_SELECTION.CLOSE_MODAL.CANCEL" />,
      cancelButtonProps: { style: { color: "black" } },
      okText: <TPP path="PAYMENT_SELECTION.CLOSE_MODAL.CONFIRM" />,
      onOk: () => {
        this.setState({
          goToBasket: true,
          ivrTimeIsUp: true,
          ivrTimeCounter: 0,
        });
      },
    });
  };

  render() {
    const {
      context,
      onSetInstallment,
      qrUrl,
      is_qrcode_email_send,
      paymentOptions,
    } = this.props;
    const { barcode, number } = context;
    const {
      installmentId,
      cardId,
      bankId,
      qrCodeShow,
      orderCreated,
      showResultText,
      paymentOptionsScreen,
      barcodeTimeIsUp,
      // deadline ı silmeyin, daha sonra aktif olacak!
      customerPhoneNumber,
      // eslint-disable-next-line no-unused-vars
      deadline,
      isAlert,
      goToBasket,
      ivrTimeIsUp,
      paymentTypeIVR,
      isQrCodeToEmailAlert,
      isClickFundTransfer,
    } = this.state;

    const redirectPaymentActive = paymentOptions.find((option) =>
      BANCONTACT_SLUGS.includes(option.slug)
    );

    const fundsTransferPaymentActive = paymentOptions.find(
      (option) => option.payment_type === FUNDS_TRANSFER_PAYMENT_TYPE
    );

    if (isQrCodeToEmailAlert) {
      return <Redirect push to={$R.MAIN_HOME.path} />;
    }
    if (goToBasket) {
      return <Redirect push to={$R.BASKET.path} />;
    }
    if (qrCodeShow || barcode) {
      document.getElementById("js-header").style.display = "none";
    }

    const localCurrentStaff =
      (localStorage.getItem("usedStorage") !== undefined &&
        localStorage.getItem("usedStorage") !== "undefined" &&
        JSON.parse(localStorage.getItem("usedStorage"))) ||
      {};

    const hasntIvrBtn = ["Teknisyen"];
    const hasntBarcodeBtn = ["Teknisyen"];

    return (
      <div className="payment-options">
        {!paymentTypeIVR &&
          barcode &&
          !qrCodeShow &&
          !paymentOptionsScreen &&
          !barcodeTimeIsUp && (
            <div className="payment-lock-screen">
              <div className="barcode-box">
                <div className="text-center">
                  <p style={{ fontSize: 28 }}>
                    {$ST.ORDER_NUMBER}: {number}
                  </p>
                  <img
                    src={`data:image/png;base64, ${barcode}`}
                    alt="barcode-image"
                    className="full-width"
                  />

                  {$STM.IS_SMS_ACTIVE === true && (
                    <div className="sms-barcode-container">
                      <p className="phone-number-text">Cep Telefonu Numarası</p>
                      <div
                        className="phone-number-input-button-container"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-around",
                          alignItems: "center",
                        }}
                      >
                        <input
                          className="phone-number-input"
                          onChange={this.setCustomerPhoneNumber}
                          value={customerPhoneNumber}
                          placeholder="Müşteri telefon numarası girin"
                        />
                        <button
                          className="send-sms-button"
                          onClick={() => this.sendSmsToCustomer()}
                        >
                          KASADA ÖDEME SMS'İ GÖNDER
                        </button>
                      </div>
                    </div>
                  )}

                  <p className="desc">
                    {$ST.WAITING_FOR_PAYMENT}
                    <br />
                    {$ST.GO_TO_CHECKOUT}
                  </p>
                  <br />
                  <button
                    className="cancel-process-button"
                    onClick={() => this.closeModal()}
                  >
                    <TPP path="PAYMENT_SELECTION.CANCEL_PROCESS" />
                  </button>
                </div>
              </div>
            </div>
          )}
        {isClickFundTransfer && (
          <FundTransferTFS
            options={context.bank_accounts}
            onCancel={this.closeModal}
            onFundsTransferChoicePage={this.onFundsTransferChoicePage}
            onPayWithFundTransfer={this.onPayWithFundTransfer}
            error={this.props.error}
          />
        )}
        {!paymentOptionsScreen && !ivrTimeIsUp && $STA.BRAND === "Samsung" && (
          <div className="payment-lock-screen">
            <div className="ivr-box">
              <div className="text-center">
                <p className="title">SİPARİŞİNİZ TAMAMLANDI</p>
                <p className="desc">Sipariş Numarası: {number}</p>
                <Button
                  className="copy-order-number"
                  onClick={() => {
                    navigator.clipboard.writeText(number);
                  }}
                >
                  Sipariş Numarasını Kopyala
                </Button>
                <div className="text-center">
                  <p style={{ marginTop: 30 }} className="title">
                    IVR ödeme onayı bekleniyor, lütfen bu sayfayı kapatmayın...
                  </p>
                </div>
                <button
                  className="cancel-process-button"
                  onClick={() => this.closeModal()}
                >
                  İşlemi İptal Et
                </button>
              </div>
            </div>

            {ivrTimeIsUp && (
              <Fragment>
                <Result
                  status="403"
                  title="IVR ÖDEMESİ BAŞARISIZ!"
                  subTitle="IVR ödemesi 30 dk boyunca kontrol edildi ancak ödeme gerçekleşmedi!"
                  extra={
                    <Button
                      onClick={() => this.againStartIvrGet()}
                      type="primary"
                    >
                      Tekrar Dene
                    </Button>
                  }
                />
              </Fragment>
            )}
          </div>
        )}

        {!paymentTypeIVR && qrCodeShow && !orderCreated && !showResultText && (
          <div className="payment-lock-screen">
            <div
              className="qr-box"
              style={{
                maxWidth: "415px",
                maxHeight: "185px",
              }}
            >
              <Fragment>
                <Countdown
                  title={<TPP path="PAYMENT_SELECTION.REMAINING_TIME" />}
                  value={this.state.deadline}
                  format="mm:ss"
                />
                <p className="qr-info-message" style={{ marginTop: "10px" }}>
                  {$ST.BANCONTACT_INFO}
                </p>
                {/* <div className='qr-code'>
                  <QRCode value={qrUrl} />
                </div> */}
                <br />
                <div className="buttons" style={{ display: "flex" }}>
                  {$BRAND_CONFIG.HAS_COPY_TO_CLIPBOARD && (
                    <button
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        copyClipboard(qrUrl);
                        this.setState({
                          copyQr: { text: "Kopyalandi", isCoppied: true },
                        });
                      }}
                      className="mr8"
                      disabled={this.state.copyQr.isCoppied}
                    >
                      {this.state.copyQr.text}
                    </button>
                  )}

                  <button
                    style={{
                      cursor: "pointer",
                      marginTop: "10px",
                    }}
                    onClick={() => this.closeModal()}
                  >
                    <TPP path="PAYMENT_SELECTION.CANCEL_PROCESS" />
                  </button>
                  {isQrCodeToEmailAlert && is_qrcode_email_send === true && (
                    <Alert
                      className="answer-alert"
                      message={<TPP path="PAYMENT_SELECTION.SUCCESSFUL" />}
                      description={
                        <TPP path="PAYMENT_SELECTION.QRCODE_SENT_EMAIL" />
                      }
                      type="success"
                      showIcon
                    />
                  )}
                  {["Samsung-tec"].includes($A.BRAND) && (
                    <button
                      style={{ cursor: "pointer", marginLeft: "12px" }}
                      onClick={() => this.sendQrCodetoEmail()}
                    >
                      <TPP path="PAYMENT_SELECTION.SEND_EMAIL" />
                    </button>
                  )}
                </div>
              </Fragment>
            </div>
          </div>
        )}

        {this.hasInstallment && this.renderInstallment()}

        <div className="qr-wrapper">
          {!paymentTypeIVR && barcodeTimeIsUp && (
            <Fragment>
              <Result
                status="403"
                title={
                  <TPP path="PAYMENT_SELECTION.BARCODE_TIME_IS_UP.TITLE" />
                }
                subTitle={
                  <TPP path="PAYMENT_SELECTION.BARCODE_TIME_IS_UP.SUBTITLE" />
                }
                extra={
                  <Button
                    onClick={() => this.againStartBarcodeGet()}
                    type="primary"
                  >
                    <TPP path="PAYMENT_SELECTION.TRY_AGAIN" />
                  </Button>
                }
              />
            </Fragment>
          )}
          {!qrCodeShow &&
            !orderCreated &&
            !showResultText &&
            paymentOptionsScreen &&
            !paymentTypeIVR &&
            redirectPaymentActive && (
              <Row type="flex" justify="center">
                <Col xs={24} md={12} lg={8} className="text-center">
                  <Button
                    className="payment-options-button"
                    classes="button pointer"
                    onClick={() => this.payWithQR()}
                  >
                    {$STM.DIRECTORY_THEME.PAYMENT_SELECTION.PAY_WITH_BANCONTACT}
                  </Button>
                </Col>
              </Row>
            )}

          {!paymentTypeIVR && showResultText && !orderCreated && (
            <Result
              status="warning"
              title={<TPP path="PAYMENT_SELECTION.PROCESS_EXPIRED.TITLE" />}
              subTitle={
                <TPP path="PAYMENT_SELECTION.PROCESS_EXPIRED.SUBTITLE" />
              }
              extra={[
                <Button
                  className="qr-button"
                  type="primary"
                  key="console"
                  onClick={() => this.handleCancel()}
                >
                  <TPP path="PAYMENT_SELECTION.BACK" />
                </Button>,
                <Button
                  className="qr-button"
                  key="buy"
                  onClick={() => this.backToPayWithQr()}
                >
                  {["Samsung-tec"].includes($A.BRAND) ? (
                    $STM.DIRECTORY_THEME.QR_PAYMENT.PAY_WITH_QR
                  ) : (
                    <TPP path="PAYMENT_SELECTION.PAY_WITH_QR" />
                  )}
                </Button>,
              ]}
            />
          )}
          {orderCreated && showResultText && (
            <Fragment>
              <Result
                status="success"
                title={<TPP path="PAYMENT_SELECTION.PAYMENT_SUCCESSFUL" />}
              />
              <Link className="button home-page-button" to={$R.HOME.path}>
                {$STM.GO_BACK_TO_HOME}
              </Link>
            </Fragment>
          )}
          {isAlert && (
            <Alert
              className="answer-alert"
              message={<TPP path="PAYMENT_SELECTION.SUCCESSFUL" />}
              description={<TPP path="PAYMENT_SELECTION.BARCODE_SENT_SMS" />}
              type="success"
              showIcon
            />
          )}
        </div>
        {localCurrentStaff.name &&
          !hasntBarcodeBtn.includes(localCurrentStaff.name) &&
          !paymentTypeIVR &&
          !qrCodeShow &&
          paymentOptionsScreen && (
            <Fragment>
              {$S.hasInstallmentOptions && (
                <Row type="flex" justify="center">
                  <Col xs={24} md={12} lg={8} className="text-center mt-15">
                    <Button
                      classes="button pointer"
                      onClick={() =>
                        this.handlePaymentTypeSelection(
                          INSTALLMENT_PAYMENT_TYPE
                        )
                      }
                    >
                      {$ST.INSTALLMENT_PAYMENT}
                    </Button>
                  </Col>
                </Row>
              )}
            </Fragment>
          )}
        {!paymentTypeIVR && installmentId && !barcode && !qrCodeShow && (
          <Row type="flex" justify="center">
            <Col xs={24} xl={5} md={10}>
              <Button
                onClick={() => onSetInstallment(installmentId)}
                classes="button pointer text-center payment-complete-button"
              >
                {$ST.ORDER_COMPLETE}
              </Button>
            </Col>
          </Row>
        )}
        {!paymentTypeIVR && bankId && cardId && !qrCodeShow && (
          <a
            className="change-card-link"
            onClick={() => this.resetCardSelection()}
          >
            {$ST.CHANGE_CARD_TYPE_TEXT}
          </a>
        )}
        <Clear />

        {fundsTransferPaymentActive &&
          paymentOptionsScreen &&
          !isClickFundTransfer && (
            <Row type="flex" justify="center">
              <Col xs={24} md={12} lg={8} className="text-center">
                <Button
                  className="payment-options-button-tfs"
                  onClick={this.onSetPaymentWithFundTransfer}
                >
                  <img
                    src={giftIcon}
                    alt="gift-icon-tfs"
                    className="gift-icon-tfs"
                  />
                  <span>{$ST.CADEAUBON_PAYMENT}</span>
                </Button>
              </Col>
            </Row>
          )}
        {localCurrentStaff.name &&
          $STA.BRAND === "Samsung" &&
          !hasntIvrBtn.includes(localCurrentStaff.name) &&
          paymentOptionsScreen && (
            <Fragment>
              <Row type="flex" justify="center">
                <Col xs={24} md={12} lg={8} className="text-center">
                  <Button
                    className="payment-options-button-ivr"
                    classes="button pointer"
                    onClick={() => this.handlePaymentTypeSelection("cash")}
                  >
                    IVR İÇİN SİPARİŞ NUMARASI YARAT
                  </Button>
                </Col>
              </Row>
            </Fragment>
          )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    customer: state.basket.customer,
    is_qrcode_email_send: state.checkout.context.is_qrcode_email_send,
  };
};

export default connect(mapStateToProps)(withRouter(PaymentOptions));



// WEBPACK FOOTER //
// ./src/theme/checkout/PaymentSelectionTFS.js